import Button from 'app/modules/shared/components/button'
import React, { useState } from 'react'
import { useTypedTranslation } from 'app/modules/shared/hooks/use-translation'
import { Form } from 'react-bootstrap'
import { handleFeedbackSubmit } from '../shared/helpers/feedback-submit'

type FeedbackModalBodyProps = {
  hideModal: () => void
  onSubmit: (canSubmit: boolean) => void
}

const FeedbackModalBody = ({ hideModal, onSubmit }: FeedbackModalBodyProps) => {
  const [descriptionText, setDescriptionText] = useState('')
  const { _t } = useTypedTranslation()
  const [selectedScore, setSelectedScore] = useState<number | undefined>(undefined)
  const scoreHasValue = selectedScore !== undefined

  return (
    <Form
      onSubmit={(e) => {
        e.preventDefault()
        handleFeedbackSubmit({
          type: 'product',
          score: selectedScore,
          description: descriptionText,
          isSuccess: onSubmit,
        })
      }}
    >
      <Form.Group style={{ width: '440px' }}>
        <Form.Group className="feedback-score-section mb-5">
          <Form.Label className="fw-medium">{_t('product-feedback-recommend-question')}</Form.Label>
          <div className="d-flex flex-row w-100">
            {Array.from({ length: 10 }, (_, i) => i + 1).map((number) => (
              <Button
                id={`product-feedback-score-${number}`}
                key={number}
                variant={`${selectedScore === number ? 'primary' : 'secondary'}`}
                className={`feedback-score-buttons ${selectedScore === number ? 'active' : 'non-active'}`}
                onClick={() => setSelectedScore(number)}
              >
                {number}
              </Button>
            ))}
          </div>
          <div className="d-flex w-full justify-content-between mt-2" style={{ color: 'rgba(72, 81, 97, 1)' }}>
            <span>1 - {_t('product-feedback-not-likely')}</span>
            <span>10 - {_t('product-feedback-extremely-likely')}</span>
          </div>
        </Form.Group>

        <Form.Group className="feedback-description-section">
          <Form.Label className="fw-medium">{_t('report-feedback-modal-title')}</Form.Label>
          <Form.Control
            as="textarea"
            id="report-feedback-description"
            name="report-feedback-description"
            placeholder={_t('write-your-message-here')}
            value={descriptionText}
            onChange={(e) => setDescriptionText(e.target.value)}
            style={{ height: '80px', width: '100%' }}
          />
        </Form.Group>

        <Form.Group className="d-flex justify-content-end" style={{ marginTop: '36px' }}>
          <div className="d-flex gap-2">
            <Button id="product-feedback-modal-close" variant="secondary" onClick={hideModal}>
              {_t('close')}
            </Button>
            <Button id="product-feedback-modal-submit" type="submit" variant="primary" disabled={!scoreHasValue}>
              {_t('submit')}
            </Button>
          </div>
        </Form.Group>
      </Form.Group>
    </Form>
  )
}

export default FeedbackModalBody
